import {FC, useMemo} from 'react'
import {RootState} from 'setup'
import {
  selectEditOrder,
  selectViewOrder,
  selectIsDirty,
  selectIsProductsEditMode,
} from 'app/features/orders/redux/order/orderEditSlice'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {Order} from 'app/features/orders/models/EditOrderState'
import SummaryFooter from 'app/features/orders/componentsv1/shared/SummaryFooter'
import {SummaryItem} from 'app/features/orders/componentsv1/shared'
import {useSelector} from 'react-redux'
import capitalize from 'lodash/capitalize'
import values from 'lodash/values'

const paymentStatusTypes = {
  pending: 'PENDING',
  failed: 'PAYMENT_FAILED',
}

type Props = {}

const PreviousOrderSummary: FC<Props> = () => {
  const order = useSelector<RootState, Order>(selectEditOrder)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const dirty = useSelector<RootState, boolean>(selectIsDirty)
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)
  const {paymentMethod} = order

  const refundAmount = useMemo(
    () => parseFloat(viewOrder.totalPrice) - parseFloat(order.totalPrice),
    [order.totalPrice, viewOrder.totalPrice]
  )

  const show = useMemo(() => {
    return values(paymentStatusTypes).includes(viewOrder.financialStatus)
  }, [viewOrder.financialStatus])

  const totalTitle = useMemo(() => {
    if (parseFloat(order.totalPrice) !== parseFloat(viewOrder.totalPrice)) {
      return 'Previous Total Paid By Customer'
    }
    return 'Total Paid By Customer'
  }, [order.totalPrice, viewOrder.totalPrice])

  if (dirty && !show)
    return (
      <>
        <SummaryFooter
          {...viewOrder}
          refundPrice={refundAmount}
          hideDiscounts
          isBetween={isProductMode}
          hidePaymentMethod={isProductMode}
          totalTitle={totalTitle}
        />

        {refundAmount < 0 && (
          <div className='card-footer'>
            <SummaryItem
              title='Amount to Be Charged'
              value={refundAmount * -1}
              isValueBolder
              isBetween={isProductMode}
              isValueSuccess
              isTitleBolder
            >
              {!isProductMode && paymentMethod && paymentMethod.id && (
                <span className='text-muted'>
                  to {capitalize(paymentMethod.card?.brand)} ending in {paymentMethod.card?.last4}
                </span>
              )}
            </SummaryItem>
          </div>
        )}
      </>
    )
  return null
}

export default PreviousOrderSummary
